<template>
  <el-button @click="doClick" :type="type" :style="{'width': width}">{{name}}</el-button>
</template>

<script>
  export default{
    props:{
      name:{
        type:String,
        default:'按 钮'
      },
      width:{
        type:String,
        default:"150px"
      },
      type:{
        type:String,
        default:'default'
      },
      params:{
        type:Object
      }
    },
    data(){
      return{

      }
    },
    methods:{
      doClick(){
        this.$emit("clickBack",this.params)
      }
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/basic/FwButton.vue